import { WorkReportType } from '../enums';

const workReportTypesInformation: { [key in WorkReportType]: string } = {
    [WorkReportType.DESIGN]: 'Design',
    [WorkReportType.REVISION]: 'Revision',
    [WorkReportType.QA]: 'QA',
    [WorkReportType.TEAM_ALIGNMENT]: 'Team Alignment',
    [WorkReportType.CLIENT_ALIGNMENT]: 'Client Alignment',
    [WorkReportType.TIME_OFF]: 'Time Off',
};

export default workReportTypesInformation;
